/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { PermitListAuthDisplay } from "cms/components/components/permit-list-auth/display";
import { PermitListAuthEditor } from "cms/components/components/permit-list-auth/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

function PermitListAuthComponent (props) {
    
    const { ...everything } = props;
    const displayText = "The permits associated with an authenticated citizen will be shown here.";
    const zoneProps = {
        ...everything,
        displayComponent: <PermitListAuthDisplay text={displayText} />,
        editComponent: <PermitListAuthEditor showCheckbox={true} />,
    };
    return getComponentZoneLayout(zoneProps);
}

PermitListAuthComponent.displayName = "PermitListAuthComponent";
export { PermitListAuthComponent };
